import { gql } from "@apollo/client";
import { MilestoneInfo } from "./getMilestonesCall";

export const CREATE_MILESTONES = gql`
  mutation Create($domain: String!, $names: [String!]!) {
    milestone {
      create(domain: $domain, names: $names) {
        name
        milestone_id
      }
    }
  }
`

export interface CreateMilestonesResponse {
  milestone: {
    create: MilestoneInfo[]
  }
}